module.exports = __webpack_public_path__ + "img/ex-contact.c9c8e6d0.jpg";